import { Stack, styled, Typography } from '@mui/material';
import { ErrorBoundaryXcala } from '../ErrorBoundaryXcala';
import { TableTransactions } from './TableTransactions';

const WrapperSection = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginTop: '-2px',
  },
}));
const TitleContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  width: '80%',
  justifyContent: 'center',
  height: '70px',
  textAlign: 'start',
  marginTop: '14px',
  maxWidth: '1200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'start',
    marginTop: '0px',
  },
}));
const TitleText = styled(Typography)(({ theme }) => ({
  marginLeft: '20px',
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
    textAlign: 'center',
  },
}));
const BodyTransaction = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '32px 24px',
  boxSizing: 'border-box',
  minHeight: '486px',
  width: '100%',
  maxWidth: '1200px',
  marginTop: '16px',
  marginBottom: '40px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '30px',
    marginTop: '8px',
  },
}));

export const BodyTransactions = ({
  loadingGetClientTransactionsPortfolio,
  tap,
  handleTaps,
  dataTransactions,
  errorGetClientTransactionsPortfolio,
}) => {
  return (
    <>
      <WrapperSection>
        <TitleContainer>
          <TitleText>Mis Transacciones</TitleText>
        </TitleContainer>
        <BodyTransaction marginTop='30px' alignItems='center'>
          <Stack width={'100%'}>
            <ErrorBoundaryXcala
              responsiveMobile
              width='100%'
              height='100%'
              imageWidth='90px'
              imageHeight='90px'
              fontSizeTop='24px'
              fontSizeBottom='24px'>
              <TableTransactions
                tap={tap}
                handleTaps={handleTaps}
                loadingGetClientTransactionsPortfolio={loadingGetClientTransactionsPortfolio}
                dataTransactions={dataTransactions}
                errorGetClientTransactionsPortfolio={errorGetClientTransactionsPortfolio}
              />
            </ErrorBoundaryXcala>
          </Stack>
        </BodyTransaction>
      </WrapperSection>
    </>
  );
};
